import React from 'react';
import { View } from 'react-native';

import { map as _map, find as _find } from 'lodash';
import PropTypes from 'prop-types';

import usageUsersPropType from '../../../../Common/PropTypes/usageUsersPropTypes';
import { USAGE_DURATION_TYPES } from '../../../Utils/Enums';
import { getFormattedDate as formatDate } from '../../../Utils/Getter';
import { PercentageUsageCard } from '../../Components';

import styles from './UnfilteredUsersUsage.Styles';

function UnfilteredUsersUsage({ users, images, ...props }) {
  return (
    <View style={styles.containerStyle}>
      {_map(users, user => {
        const monthUsage = _find(user.usagePeriods, p => p.period === USAGE_DURATION_TYPES.MONTH);
        const { startDate, endDate, period, usageData } = monthUsage;
        return (
          <PercentageUsageCard
            title={user.name}
            date={formatDate({ startDate, endDate, period })}
            usageData={usageData}
            images={images}
            containerStyle={styles.itemContainerStyle}
          />
        );
      })}
    </View>
  );
}

UnfilteredUsersUsage.propTypes = {
  users: usageUsersPropType,
  images: PropTypes.object,
};

export default UnfilteredUsersUsage;
